<template>
  <div class="min-h-screen flex flex-col text-primary-100 bg-head-office-20">
    <div class="flex items-center justify-center py-20 flex-grow">
      <div class="max-w-md mx-auto text-center p-6">
        <div class="mb-8">
          <h1 class="text-6xl font-bold text-gray-900 mb-4">{{ error.statusCode }}</h1>
          <h2 class="text-2xl font-semibold text-gray-700 mb-2">
            {{ error.statusCode === 404 ? 'Page Not Found' : 'An Error Occurred' }}
          </h2>
        </div>

        <div class="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <h3 class="text-sm font-semibold text-amber-800 mb-2">Debug Info</h3>
          <div class="text-xs text-amber-700 space-y-1">
            <p><strong>Status Code:</strong> {{ error.statusCode }}</p>
            <p><strong>Message:</strong> {{ error.message }}</p>
            <p><strong>URL:</strong> {{ error.url || route.path }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  error: Object,
})

const route = useRoute()

const handleError = () => {
  clearError({ redirect: '/' })
}

useHead({
  title: `${props.error?.statusCode || 'Error'} - ${props.error?.message || 'An error occurred'} | Gro-up`,
  meta: props.error?.statusCode === 404 ? [{ name: 'robots', content: 'noindex, nofollow' }] : [],
})
</script>

